import PropTypes from 'prop-types';
import { Icon } from '../common/Icons';
import {
  StyledContainer,
  StyledTitleContainer,
  StyledTitle,
  StyledList,
  StyledListItem,
  StyledListLink,
  StyledDescContainer,
  StyledDescHeading,
  StyledDescText,
  StyledIconsList,
  StyledIconsItem,
  StyledIconsLink,
  StyledExtraList,
  StyledExtraItem,
  StyledExtraLink,
} from './ExploreSidebar.styles';

function ExploreSidebar({ data, hasIcon }) {
  if (!Object.keys(data).length) return null;

  return (
    <StyledContainer>
      {data.title && (
        <StyledTitleContainer>
          {hasIcon && <Icon.Search aria-hidden />}
          <StyledTitle>{data.title}</StyledTitle>
        </StyledTitleContainer>
      )}
      {data.list && (
        <StyledList>
          {data.list.map(item => (
            <StyledListItem key={item.id}>
              <StyledListLink
                to={item.link === 'yoga' ? `/category${item.link}` : ''}
                circle={item.color || 'white'}
              >
                {item.title && item.title}
              </StyledListLink>
            </StyledListItem>
          ))}
        </StyledList>
      )}
      {data.description && (
        <StyledDescContainer>
          {data.description.heading && (
            <StyledDescHeading>{data.description.heading}</StyledDescHeading>
          )}
          {data.description.text && <StyledDescText>{data.description.text}</StyledDescText>}
        </StyledDescContainer>
      )}
      {data.socialLinks && (
        <StyledIconsList>
          {data.socialLinks.map(item => (
            <StyledIconsItem key={item.id}>
              <StyledIconsLink href={item.link} title={item.name}>
                {item.icon === 'youtube' ? (
                  <Icon.YoutubeMin aria-hidden />
                ) : item.icon === 'tiktok' ? (
                  <Icon.Tiktok aria-hidden />
                ) : item.icon === 'twitter' ? (
                  <Icon.Twitter aria-hidden />
                ) : item.icon === 'instagram' ? (
                  <Icon.Instagram aria-hidden />
                ) : null}
              </StyledIconsLink>
            </StyledIconsItem>
          ))}
        </StyledIconsList>
      )}
      {data.links && (
        <StyledExtraList>
          {data.links.map(item => (
            <StyledExtraItem key={item.id}>
              <StyledExtraLink to={item.link}>{item.title}</StyledExtraLink>
            </StyledExtraItem>
          ))}
        </StyledExtraList>
      )}
    </StyledContainer>
  );
}

ExploreSidebar.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    list: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        color: PropTypes.string,
        link: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      })
    ),
    socialLinks: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        icon: PropTypes.string.isRequired,
        name: PropTypes.string,
        link: PropTypes.string.isRequired,
      })
    ),
    links: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
      })
    ),
  }),
  hasIcon: PropTypes.bool,
};

ExploreSidebar.defaultProps = {
  data: {},
  hasIcon: true,
};

export default ExploreSidebar;
